export const STATUS = {
  PENDING: "Pending",
  FAILED: "Failed",
  VALIDATING: "Validating",
  LOADING: "Loading",
  LOADED: "Loaded",
};
